<div class="tool-modal">
    <div class="tool-modal__header">
        <h3>{{ title }}</h3>
        <button type="button" class="tool-modal__close" (click)="activeModal.dismiss()" [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    <form class="tool-modal__body" (ngSubmit)="submit()">
        <div class="customer-line">
            <span>{{ 'gateways_table_customer' | translate }}</span>
            <strong>{{ gateway.customerName || gateway.descr || '—' }}</strong>
        </div>

        @if (mode === 'username') {
            <!-- What is being replaced. Without it the admin is renaming an
                 account whose current login is nowhere on the page: the table
                 shows the customer name, never the username. -->
            <div class="customer-line">
                <span>{{ 'gateway_tool_current_username' | translate }}</span>
                <strong>{{ gateway.username || ('gateway_tool_unknown' | translate) }}</strong>
            </div>
            <!-- The username is the cloud login, so this renames the account, not
                 this gateway. Say so when the account owns others — the clicked
                 row's customer name is often not the same as the siblings'. -->
            @if (siblingGateways.length) {
                <p class="scope-warning">
                    {{ 'gateway_tool_scope_warning' | translate: { count: siblingGateways.length } }}
                    <strong>{{ siblingLabels }}</strong>
                </p>
            }
            <label class="field">
                <span>{{ 'gateway_tool_new_username' | translate }}</span>
                <input ngbAutofocus type="email" name="newUsername" [(ngModel)]="newUsername" autocomplete="off" required />
            </label>
        } @else if (mode === 'password') {
            <label class="field">
                <span>{{ 'account_new_password' | translate }}</span>
                <input ngbAutofocus type="password" name="newPassword" [(ngModel)]="newPassword" autocomplete="new-password" required />
            </label>
            <label class="field">
                <span>{{ 'gateway_tool_confirm_new_password' | translate }}</span>
                <input type="password" name="confirmPassword" [(ngModel)]="confirmPassword" autocomplete="new-password" required />
            </label>
        } @else {
            <div class="field">
                <span>{{ 'gateway_tool_old_uid' | translate }}</span>
                <input type="text" [value]="gateway.uid" disabled />
            </div>
            <div class="field">
                <span>{{ 'gateway_tool_replace_with' | translate }}</span>
                <ng-select
                    class="tool-select"
                    name="replacementUid"
                    [items]="candidateOptions"
                    bindLabel="label"
                    bindValue="uid"
                    [placeholder]="'gateway_tool_select_placeholder' | translate"
                    [clearable]="false"
                    [(ngModel)]="replacementUid">
                </ng-select>
            </div>
        }

        @if (error) {
            <p class="error">{{ error }}</p>
        }

        <button type="submit" class="tool-modal__submit" [disabled]="submitting">{{ 'admin_action_save' | translate }}</button>
    </form>
</div>
